export const GLOBAL_STATE = 'EducationPlace'

export const EDUCATION_PLACE = 'EDUCATION_PLACE' as const
export const EDUCATION_PLACE_CREATE = 'EDUCATION_PLACE_CREATE' as const
export const EDUCATION_PLACE_DELETE = 'EDUCATION_PLACE_DELETE' as const
export const EDUCATION_PLACE_LIST = 'EDUCATION_PLACE_LIST' as const
export const EDUCATION_PLACE_ALL = 'EDUCATION_PLACE_ALL' as const
